import { css } from '@linaria/atomic';
import { ContainedIcon } from '@frontend/icons';
import { theme } from '@frontend/theme';

const warnContainedIconStyle1 = css`
  padding: 1px;
  border-radius: var(--fabric-radius-sm);
`;

export const Warn = ({ as = 'span' }: { as?: React.ElementType }) => {
  return (
    <ContainedIcon
      as={as}
      className={warnContainedIconStyle1}
      iconName='aineeds-attention'
      background={theme.colors.gradients.warn}
      color={theme.colors.warning70}
    />
  );
};
